import React from "react";
import { BiGift } from "react-icons/bi";
import { MdOutlineAddShoppingCart } from "react-icons/md";
import ReadMore from "../../../../features/ReadMore";
import { Assort } from "../../../models/Assort";
import useBasketManager from "../../SaleMovie/CinemaHall/hooks/useBasketManager";
import "../style.scss";
import "./../../Passes/SinglePass/style.scss";
import { useTranslation } from "react-i18next";

interface IProps {
  item: Assort;
}

const SingleGiftCard: React.FC<IProps> = ({ item }: IProps) => {
  const { handleAddBasketLimited } = useBasketManager();
  const { t } = useTranslation();
  return (
    <div className="singlePass">
      <div className="img" style={{ backgroundImage: `url(${item.picture})` }}></div>
      <div className="content">
        <div className="text">
          <h3>{item.displayWebName}</h3>
          {item.description.length > 120 ? (
            <ReadMore text={item.description} minLengthText={120} title={item.displayWebName} />
          ) : (
            <article dangerouslySetInnerHTML={{ __html: item.description }}></article>
          )}
        </div>
        <div className="line"></div>
        <div className="buttons flex-between-center">
          <div className="flex-column flex-wrap">
            <b>
              {item.price} {t("zl")}
            </b>
            {/* <span>Ważność {item.dayValidate} dni</span> */}
          </div>
          <button
            onClick={() => {
              handleAddBasketLimited(item, 1);
            }}
            className="button medium padding-medium button-fill-main"
          >
            {t("dodaj")}
            <MdOutlineAddShoppingCart className="icon" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SingleGiftCard;
